<template>
  <nav-bar title="经营企业本区客户列表" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
     <ul class="list">
      <li
        class="list-item"
        v-for="item in list"
        :key="item.id"
        @click="$router.push(`/userInfo/${item.userId}`)"
      >
        <div class="list-item__name">
          {{item.companyName}}
        </div>
        <div class="list-item__desc">
          <span>联系人：</span>
          <span>{{item.userName ? item.userName : '未知' }}</span>
        </div>
        <div class="list-item__desc">
          <span>联系电话：</span>
          <span>{{item.phoneNum ? item.phoneNum : '未知' }}</span>
        </div>
        <div class="list-item__desc">
          <span>地址：</span>
          <span>{{item.address ? item.address : '未知' }}</span>
        </div>
      </li>
     </ul>
    <Empty v-if="!list.length && !showLoading" description="暂无记录" />
  </Content>
</template>

<script>
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { getStreetCompanyCustList } from '@/api/customer'
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
export default {
  name: 'BusinessEnterpriseDetail',
  props: ['id'],
  setup (props) {
    const store = useStore()
    const streetCode = computed(() => store.state.roleInfo.companyId)
    const list = ref([])
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getStreetCompanyCustList, (data) => {
      list.value = data
    }, {
      streetCode: streetCode.value,
      companyId: props.id
    })
    getDataLoading()
    return { getDataLoading, showLoading, isLoading, list }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 16px;
  padding-bottom: 0;
  font-size: 14px;
  color: #333;
  .list-item {
    padding: 14px;
    background-color: #fff;
    box-shadow: rgba(87, 107, 146, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    &__name {
      font-weight: 600;
      line-height: 24px;
    }
    &__desc {
      font-size: 12px;
      color: #666;
      line-height: 22px;
    }
  }
}
</style>
